import { AnalyticRegionStateType } from '@/enums/analyticRegionStateType';

export function getColor(state: AnalyticRegionStateType): string {
  switch (state) {
    case AnalyticRegionStateType.CurationRequired:
      return 'red';
    case AnalyticRegionStateType.UnderCuration:
      return 'orange';
    case AnalyticRegionStateType.Curated:
      return 'blue';
    case AnalyticRegionStateType.CurationBlocked:
      return 'black';
    case AnalyticRegionStateType.Approved:
      return 'green';
    default:
      return 'white';
  }
}
